import { ButtonVariant } from "@silversea-ssc/ui-components-react";
import { match, P } from "ts-pattern";
import { Scalars } from "types/graphql-types";
import { PageBuilderButtonCTAProps } from "./PageBuilderButtonCTA";

export const toButtonVariantProps = (
  variant: Scalars["SanityButtonType"]["output"] | undefined,
  defaultVariant: ButtonVariant | undefined = undefined
): { variant: ButtonVariant | undefined; inverted?: boolean } => {
  return (
    match(variant)
      .with(P.nullish, () => ({ variant: defaultVariant }))
      .with("primary", "new_primary", () => ({ variant: "primary" as const }))
      .with("new_primary_inverted", () => ({
        variant: "primary" as const,
        inverted: true
      }))
      .with("new_accent", () => ({ variant: "accent" as const }))
      .with("new_accent_inverted", () => ({
        variant: "accent" as const,
        inverted: true
      }))
      .with("secondary", "new_secondary", () => ({
        variant: "secondary" as const
      }))
      .with("new_secondary_inverted", () => ({
        variant: "secondary" as const,
        inverted: true
      }))
      .with("secondary-gray", () => ({ variant: "secondary" as const }))
      .with("tertiary", () => ({ variant: "secondary" as const }))
      .with(
        "link",
        "new_text",

        () => ({ variant: "text" as const })
      )
      .with("new_text_inverted", () => ({
        variant: "text" as const,
        inverted: true
      }))
      .with("new_link", () => ({ variant: "link" as const }))
      // .otherwise((v) => v);
      .exhaustive()
  );
};

function toHeroCTAButtonVariant(
  button: undefined,
  inverted?: boolean
): undefined;
function toHeroCTAButtonVariant(
  button: PageBuilderButtonCTAProps,
  inverted?: boolean
): PageBuilderButtonCTAProps;
function toHeroCTAButtonVariant(
  button: PageBuilderButtonCTAProps | undefined,
  inverted?: boolean
): PageBuilderButtonCTAProps | undefined {
  if (!button) return undefined;
  const fixedVariant = match(button.variant)
    .with("primary", () => ({
      defaultButtonVariant: "accent" as const,
      inverted: !!inverted
    }))
    .with("secondary", () => ({
      defaultButtonVariant: "primary" as const,
      inverted: !!inverted
    }))
    .with("secondary-gray", () => ({
      defaultButtonVariant: "primary" as const,
      inverted: !!inverted
    }))
    .with("tertiary", () => ({
      defaultButtonVariant: "secondary" as const,
      inverted: !!inverted
    }))
    .with("link", () => ({
      defaultButtonVariant: "text" as const,
      inverted: !!inverted
    }))
    .with("new_primary", () => ({
      defaultButtonVariant: "primary" as const
    }))
    .with("new_accent", () => ({
      defaultButtonVariant: "accent" as const
    }))
    .with("new_secondary", () => ({
      defaultButtonVariant: "secondary" as const
    }))
    .with("new_text", () => ({
      defaultButtonVariant: "text" as const
    }))
    .with("new_link", () => ({
      defaultButtonVariant: "link" as const
    }))

    .with("new_primary_inverted", () => ({
      defaultButtonVariant: "primary" as const,
      inverted: true
    }))
    .with("new_accent_inverted", () => ({
      defaultButtonVariant: "accent" as const,
      inverted: true
    }))
    .with("new_secondary_inverted", () => ({
      defaultButtonVariant: "secondary" as const,
      inverted: true
    }))
    .with("new_text_inverted", () => ({
      defaultButtonVariant: "text" as const,
      inverted: true
    }))
    .with(P.nullish, () => ({
      defaultButtonVariant: "accent" as const,
      inverted: !!inverted
    }))
    .exhaustive();

  return {
    ...button,
    variant: undefined,
    ...fixedVariant
  };
}

export { toHeroCTAButtonVariant };
